class ProductMenuSwitcher {
  constructor({ menuEl, mobile }) {
    this._menuEl = menuEl;
    this._mobile = mobile;

    this._activeElements = [];

    // tab container
    this._tabContainer = this._menuEl.querySelector(
      ".sales-view__tab-container"
    );

    this._activeTabPanelClass = "sales-view__product-grid--active";
    this._activeTabButtonClass = "sales-view__menu-item--active";
  }

  init() {
    this._tabButtons = [...this._menuEl.querySelectorAll('[role="tab"]')];

    this._tabPanels = [...this._menuEl.querySelectorAll('[role="tabpanel"]')];

    // create button to tab map
    this._buttonToTabMap = this._tabButtons.reduce(
      (map, btn) => ({
        ...map,
        [btn.getAttribute("aria-controls")]: [
          btn,
          this._tabPanels.find(
            (t) =>
              t.getAttribute("aria-labelledby") ===
              btn.getAttribute("aria-controls")
          ),
        ],
      }),
      {}
    );

    this._setEventListeners();

    // find tab with aria-selected
    const defaultTabButton =
      this._tabButtons.find((t) => t.ariaSelected === "true") ||
      this._tabButtons[0];
    // const defaultTabPanel =
    //   this._buttonToTabMap[defaultTabButton.getAttribute("aria-controls")];
    this._switchTab(defaultTabButton.getAttribute("aria-controls"));
  }

  _setEventListeners() {
    // tab buttons
    this._tabButtons.forEach((btn) =>
      btn.addEventListener("click", this._handleTabButtonClick.bind(this))
    );

    if (this._mobile) {
      window.addEventListener(
        "resize",
        this._setHeightToTabContainer.bind(this)
      );
    }
  }

  _setHeightToTabContainer() {
    // get offset from top
    this._tabContainer.style.maxHeight = `calc(100vh - ${
      this._tabContainer.getBoundingClientRect().top + 10
    }px)`;
  }

  _handleTabButtonClick(e) {
    const tabLabel = e.target.getAttribute("aria-controls");
    this._switchTab(tabLabel);
  }

  _hideTab(tabEl) {
    // tabEl.classList.remove(this._activeTabPanelClass);
    tabEl.classList.add("sales-view__product-grid--inactive");
    setTimeout(() => {
      tabEl.classList.remove("sales-view__product-grid--active");
      tabEl.classList.remove("sales-view__product-grid--inactive");
    }, 150);
  }

  _showTab(tabEl) {
    tabEl.classList.add(this._activeTabPanelClass);
  }

  _deactivateButton(buttonEl) {
    buttonEl.setAttribute("aria-selected", "false");
    buttonEl.classList.remove(this._activeTabButtonClass);
  }

  _activateButton(buttonEl) {
    buttonEl.setAttribute("aria-selected", "true");
    buttonEl.classList.add(this._activeTabButtonClass);
  }

  _switchTab(label) {
    const [activeBtn, activeTab] = this._activeElements;
    const [newBtn, newTab] = this._buttonToTabMap[label];

    if (activeBtn === newBtn) return;

    if (!newBtn || !newTab)
      return console.error(`No index found for "${label}"`);
    if (this._activeElements.length) {
      this._deactivateButton(activeBtn);
      this._hideTab(activeTab);
    }
    this._activateButton(newBtn);
    this._showTab(newTab);
    this._activeElements = [newBtn, newTab];
  }
}

export default ProductMenuSwitcher;
